import edit_button from "../edit_button.html";
import filter_package_btn from "../filter_package_btn.html";
import drag_drop from "../drag_drop_package/drag_and_drop_template.html";

window.doExport = function() {
  let id = document.getElementsByClassName('myBtn')[0].dataset.id;
  fetch(window.location.protocol+'//'+window.location.host+'/api/livepackages-export/'+id,
  {
    method: 'GET',
    headers: {
        'Authorization': window.localStorage.getItem('userToken'),
    }
  })
      .then((response) => response.json())
      .then((data) => {
        window.location.href = data.file_url;
      })
      .catch((error) => {
          console.log("error: ", error);
      });
}

export default function (nga, admin) {
  var livepackages = admin.getEntity("livepackages");
  livepackages._views.ShowView._enabled = true;
  livepackages
    .listView()
    .title(
      '<h4>All Packages <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>'
    )
    .permanentFilters({ package_type_id: [1, 2] })
    .batchActions([])
    .fields([
      nga.field("id").label("Package ID"),
      nga.field("package_name").isDetailLink(false).label("Package Name"),
      nga.field("type", "choice").choices([
        { value: 0, label: "FTA" },
        { value: 1, label: "Pay Package" },
      ]).isDetailLink(false).label("Type"),
      nga.field("definition", "choice")
      .choices([
        { value: 1, label: "HD" },
        { value: 0, label: "SD" },
      ]).isDetailLink(false).label("Definition"),
      nga
        .field("package_type_id", "reference")
        .targetEntity(admin.getEntity("packagetypes"))
        .targetField(nga.field("description"))
        .isDetailLink(false)
        .cssClasses("hidden-xs")
        .label("Package Type"),
    ])
    .filters([
      nga.field('q')
      .label('')
      .template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search" class="form-control"><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>')
      .pinned(true),
    ])
    .listActions(["edit", "show"])
    .exportFields([livepackages.listView().fields()]);

  livepackages
    .creationView()
    .title(
      '<h4>Packages <i class="fa fa-angle-right" aria-hidden="true"></i> Create: Package</h4>'
    )
    .onSubmitSuccess([
      "progression",
      "notification",
      "$state",
      "entry",
      "entity",
      function (progression, notification, $state, entry, entity) {
        notification.log(`Package created successfully`, {
          addnCls: "humane-flatty-success",
        });
        // redirect to the list view
        $state
          .go($state.current, {}, { reload: true })
          .then($state.go($state.get("list"), { entity: entity.name() })); // cancel the default action (redirect to the edition view)
      },
    ])
    .fields([
      nga
        .field("package_name", "string")
        .attributes({ placeholder: "Name the package you are creating" })
        .validation({ required: true })
        .label("Package Name"),
      nga
        .field("package_type_id", "reference")
        .targetEntity(admin.getEntity("packagetypes"))
        .targetField(nga.field("description"))
        .attributes({
          placeholder: "Choose the Package Type from dropdown list",
        })
        .validation({
          validator: function (value) {
            if (value === null || value === "") {
              throw new Error("Please Select Package Type");
            }
          },
        })
        .permanentFilters({ package_type_id: [1, 2] })
        .label("Package Type"),
      nga
        .field("type", "choice")
        .choices([
          { value: 0, label: "FTA" },
          { value: 1, label: "Pay Package" },
        ])
        .attributes({ placeholder: "Package Type" })

        .validation({ required: false })
        .label("Type"),
      nga
        .field("definition", "choice")
        .choices([
          { value: 1, label: "HD" },
          { value: 0, label: "SD" },
        ])
        .attributes({ placeholder: "Package Quality" })

        .validation({ required: false })
        .label("Definition"),
      nga.field("template").label("").template(edit_button),
    ]);

  livepackages
    .editionView()
    .title(
      '<h4>Packages <i class="fa fa-angle-right" aria-hidden="true"></i> Edit: {{ entry.values.package_name }}</h4>'
    )
    .actions(["list"])
    .fields([
      nga
        .field("package_name", "string")
        .attributes({ placeholder: "Package Name" })
        .validation({ required: true })
        .label("Package Name"),
      nga
        .field("package_type.description", "string")
        .attributes({ readOnly: true })
        .label("Package Type"),
      nga
        .field("type", "choice")
        .choices([
          { value: 0, label: "FTA" },
          { value: 1, label: "Pay Package" },
        ])
        .attributes({ placeholder: "Package Type" })

        .validation({ required: false })
        .label("Type"),
      nga
        .field("definition", "choice")
        .choices([
          { value: 1, label: "HD" },
          { value: 0, label: "SD" },
        ])
        .attributes({ placeholder: "Package Quality" })

        .validation({ required: false })
        .label("Definition"),
      nga.field("template").label("").template(edit_button),
      nga.field("", "template").label("").template(drag_drop),
      // nga.field('packagechannels', 'referenced_list')
      //     .label('Channels')
      //     .targetEntity(admin.getEntity('packagechannels'))
      //     .targetReferenceField('package_id')
      //     .targetFields([
      //         nga.field('channel_id', 'reference')
      //             .targetEntity(admin.getEntity('Channels'))
      //             .targetField(nga.field('channel_number'))
      //             .label('Nr'),
      //         nga.field('channel_id', 'reference')
      //             .targetEntity(admin.getEntity('Channels'))
      //             .targetField(nga.field('icon_url', 'file')
      //                 .template('<img src="{{ entry.values.icon_url }}" height="35" width="35" />'))
      //             .label('Icon'),
      //         nga.field('channel_id', 'reference')
      //             .targetEntity(admin.getEntity('Channels'))
      //             .targetField(nga.field('title'))
      //             .label('Channels'),
      //         nga.field('channel_id', 'reference')
      //             .targetEntity(admin.getEntity('Channels'))
      //             .targetField(nga.field('genre.description'))
      //             .label('Genre'),
      //         nga.field('channel_id', 'reference')
      //             .targetEntity(admin.getEntity('Channels'))
      //             .targetField(nga.field('isavailable', 'boolean'))
      //             .label('available'),
      //     ])
      //     .listActions(['<ma-delete-button label="Remove" entry="entry" entity="entity" size="xs"></ma-delete-button>'])
      //
      //     .perPage(15),
      // nga.field('template')
      //     .label('')
      //     .template(filter_package_btn),
    ]);

  livepackages
    .showView()
    .title(
      '<h4>Logs <i class="fa fa-angle-right" aria-hidden="true"></i> Details</h4>'
    )
    .actions(['<button class="btn btn-default myBtn" type="button" onclick="window.doExport()" data-id={{entry.values.id}}>Export</button>'])
    .fields([
      nga.field("package_name", "string").label("Package Name"),
      nga.field("package_type.description", "string").label("Package Type"),
      nga.field("type", "string").label("Type"),
      nga.field("defination", "string").label("Defination"),
      nga.field("template").label("").template(edit_button),
      nga.field("", "template").label("").template(drag_drop),
    ]);
  return livepackages;
}



// WEBPACK FOOTER //
// ./js/livepackages/config.js